import { Component, ElementRef, Inject, OnInit, ViewChild, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { NgIf } from '@angular/common';

declare const katex: any;

export interface EquationDialogData {
  latex: string;
}

@Component({
  selector: 'mce-equation-editor-dialog',
  standalone: true,
  imports: [FormsModule, MatDialogModule, MatButtonModule, NgIf],
  templateUrl: './equation-editor-dialog.component.html',
  styleUrl: './equation-editor-dialog.component.scss',
})
export class EquationEditorDialogComponent implements OnInit {
  @ViewChild('preview', { static: true }) previewEl!: ElementRef<HTMLDivElement>;

  latex = signal('');
  hasError = signal(false);

  constructor(
    private readonly dialogRef: MatDialogRef<EquationEditorDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: EquationDialogData,
  ) {
    this.latex.set(data?.latex ?? '');
  }

  ngOnInit() {
    this.renderPreview();
  }

  onLatexChange(value: string) {
    this.latex.set(value);
    this.renderPreview();
  }

  private renderPreview() {
    const el = this.previewEl.nativeElement;
    const src = this.latex().trim();
    if (!src) {
      el.innerHTML = '<span class="eq-placeholder">Preview will appear here</span>';
      this.hasError.set(false);
      return;
    }
    try {
      el.innerHTML = katex.renderToString(src, { displayMode: true, throwOnError: true });
      this.hasError.set(false);
    } catch {
      el.innerHTML = '<span class="eq-error">Invalid LaTeX — check your expression</span>';
      this.hasError.set(true);
    }
  }

  insert() {
    if (!this.hasError() && this.latex().trim()) {
      this.dialogRef.close(this.latex().trim());
    }
  }

  cancel() {
    this.dialogRef.close(null);
  }
}
